import { InfoCard } from '@backstage/core-components';
import { Typography } from '@material-ui/core';

/**
 * Placeholder for the "Team on-call" widget shown in the PAT-605 mockup.
 *
 * No on-call rotation data source (PagerDuty/Opsgenie/etc.) is wired up yet,
 * so this renders a plain placeholder rather than fabricated names — the
 * card stays in the grid (matching the mockup's 2x2 layout) until a real
 * source is chosen.
 */
export const TeamOnCallCard = () => (
  <InfoCard title="Team on-call">
    <Typography variant="body2" color="textSecondary">
      No on-call data source configured yet.
    </Typography>
  </InfoCard>
);
